import { Component, OnInit, Input } from '@angular/core';
import { RtTripErrorService } from '@bds/railtrac';
import { RtJeopardizedShipment, RtvTripError } from '@bds/railtrac-models';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'rt-jeopardized-shipment-never-shipped',
    templateUrl: './rt-jeopardized-shipment-never-shipped.component.html',
    styleUrls: ['./rt-jeopardized-shipment-never-shipped.component.scss'],
})
export class RtJeopardizedShipmentNeverShippedComponent implements OnInit {
    @Input() shipment: RtJeopardizedShipment;
    @Input() addTripRouterLink: [];
    tripError: RtvTripError;
    gridSource;

    constructor(private tripErrorService: RtTripErrorService) {}

    addNewTrip() {}

    onResolve(event) {}

    removeFromFleet() {}

    ngOnInit() {
        this.getTripError();
        this.gridSource = this.getODataTripErrorApiSource();
    }

    getODataTripErrorApiSource(): DataSource {
        const ds = this.tripErrorService.getTripErrorDataSource();
        if (this.shipment) {
            if (this.shipment) {
                ds.filter([
                    ['carInit', '=', this.shipment.carInitials],
                    'and',
                    ['carNo', '=', this.shipment.carNumber],
                ]);
            } else {
                ds.filter([
                    ['carInit', '=', this.shipment.carInitials],
                    'and',
                    ['carNo', '=', this.shipment.carNumber],
                ]);
            }
            ds.sort({ selector: 'ormId', desc: true });
        }
        return ds;
    }

    getTripError() {
        if (!this.shipment?.carInitials || !this.shipment?.carNumber) {
            return;
        }

        this.tripErrorService
            .findLatestTripError(this.shipment.carInitials, this.shipment.carNumber)
            .subscribe({
                next: (tripErrors: RtvTripError[]) => {
                    if (tripErrors && tripErrors.length > 0) {
                        // Get the first (latest) trip error
                        this.tripError = tripErrors[0];
                    } else {
                        this.tripError = null;
                    }
                },
                error: (error) => {
                    this.tripError = null;
                },
            });
    }
}
